import {defineMessages} from 'react-intl'

export const MODULE_TYPES = {
    ARTICLE: 'article',
    PRODUCT: 'product',
    CAROUSEL: 'carousel'
}

export const MODULE_TYPE_LABELS = defineMessages({
    [MODULE_TYPES.ARTICLE]: {
        id: 'global.article',
        defaultMessage: 'article'
    },
    [MODULE_TYPES.PRODUCT]: {
        id: 'global.product',
        defaultMessage: 'Product'
    },
    [MODULE_TYPES.CAROUSEL]: {
        id: 'global.carousel',
        defaultMessage: 'carousel'
    }
})
